import React, { useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Image, Breadcrumb, Grid, Header, Button, Icon, Segment, Card } from 'semantic-ui-react';

type SectionCardProps = {
    sectionData: SectionData;
    onMouseDown: Function;
    onDropEnter: Function;
    isDragging: React.RefObject<boolean>;
    draggingId: React.RefObject<number>;
}

export type SectionData = {
    title: string,
    teaserText: string,
    backgroundColor: string,
    displayOrder: number,
    homepageSectionId: number,
    iconName: number,
    url: string,
    isHtmlContent: boolean,
    pageContent?: string,
    pageContentContext? : string,
};

export const SectionCard: React.FC<SectionCardProps> = ({isDragging, onMouseDown, sectionData, onDropEnter, draggingId}) => {
    const history = useHistory();
    
    const cardDom = useRef();

    function handleMousedown(event: React.MouseEvent, sectionId: number){
        event.stopPropagation();
        event.preventDefault();
        if(event.nativeEvent.which === 1){
            onMouseDown(event.nativeEvent, sectionId);
        }
    }

    function onMouseEnter(event: React.MouseEvent){
        event.stopPropagation();
        event.preventDefault();
        if(isDragging.current === true && draggingId.current !== sectionData.homepageSectionId){
            onDropEnter(sectionData.homepageSectionId);
        }
    };
    
    return (
        <div id={`section-card-${sectionData.homepageSectionId}`} className='home-page-section-card' style={{ backgroundColor: sectionData.backgroundColor }} onMouseDown={(event: React.MouseEvent)=>{
            handleMousedown(event, sectionData.homepageSectionId);
        }}
            onMouseEnter={onMouseEnter}
        >

            <Image
                className='home-page-section-card-icon'
                src={
                    `${process.env.REACT_APP_VIRTUAL_DIRECTORY}/assets/images/svg/${sectionData.iconName}`
                } size='small' />
            <Header>
                {sectionData.title}
            </Header>
            <p>{sectionData.teaserText}</p>
            <div className='home-page-section-card-edit-button' 
            title='Click to edit this section.'
            onMouseDown={(event: React.MouseEvent)=>{
                event.stopPropagation();event.preventDefault();
                history.push(`/editHomepageSection/${sectionData.homepageSectionId}`)}}
                onMouseUp = {(e: React.MouseEvent)=>{
                    e.stopPropagation();
                    e.preventDefault();
                }}
                >
                <Icon name={'edit'} size={'large'}></Icon>
            </div>
            {/* <div className='home-page-section-card-order-number'>
                {`Display order: ${sectionData.displayOrder}`}
            </div> */}
        </div>
    );
}